function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTileSnowLastHour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128.69 128.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.69,
    height: 128.69,
    rx: 17.64,
    style: {
      fill: "#ff01bf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.81,102.27,64.6,98.69l3.72-1.61a2.57,2.57,0,0,0-2-4.71l-7.22,3.11-9.61-5.54,9.61-5.55,7.22,3.12a2.57,2.57,0,0,0,2-4.72l-3.72-1.6,6.21-3.59a2.57,2.57,0,1,0-2.57-4.45L62,76.73l.47-4a2.57,2.57,0,0,0-5.11-.58l-.91,7.81-9.61,5.55V74.39l6.31-4.69a2.57,2.57,0,1,0-3-4.13L46.87,68V60.81a2.57,2.57,0,0,0-5.14,0V68l-3.25-2.41a2.57,2.57,0,0,0-3.06,4.13l6.31,4.69v11.1l-9.6-5.55-.91-7.81a2.57,2.57,0,0,0-5.11.58l.47,4-6.21-3.58A2.57,2.57,0,0,0,17.8,77.6L24,81.19l-3.72,1.6a2.57,2.57,0,0,0,2.05,4.72l7.21-3.12,9.61,5.55-9.61,5.54-7.21-3.11a2.57,2.57,0,0,0-2.05,4.71L24,98.69l-6.21,3.58a2.57,2.57,0,0,0,1.28,4.8,2.53,2.53,0,0,0,1.29-.35l6.21-3.58-.47,4a2.57,2.57,0,1,0,5.11.58l.91-7.8,9.6-5.55v11.09l-6.31,4.69a2.57,2.57,0,0,0,3.06,4.14l3.25-2.42v7.17a2.57,2.57,0,0,0,5.14,0v-7.17l3.26,2.42a2.57,2.57,0,0,0,3-4.14l-6.31-4.69V94.39l9.61,5.55.91,7.8a2.57,2.57,0,1,0,5.11-.58l-.47-4,6.21,3.58a2.5,2.5,0,0,0,1.28.35,2.57,2.57,0,0,0,1.29-4.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.64,71.41a3.5,3.5,0,0,1-3.5-3.5V42l-1.39,1.22A3.5,3.5,0,0,1,74.14,38l7.2-6.3a3.49,3.49,0,0,1,5.8,2.63V67.91A3.5,3.5,0,0,1,83.64,71.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,56H58.48a3.5,3.5,0,1,1,0-7H66.8a3.5,3.5,0,0,1,0,7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.83,45.78a3,3,0,0,0-4.2-.59l-6.88,5.2L26.59,50l-5.32-7a3,3,0,1,0-4.79,3.6l8.39,11.17a3,3,0,0,0,1.62,1.08l.11,0A2.7,2.7,0,0,0,27,59l.12,0h.39a3.4,3.4,0,0,0,.46-.07h0a3,3,0,0,0,1.36-.73L40.23,50a2.23,2.23,0,0,0,.4-.35A3,3,0,0,0,40.83,45.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.35,20.25a2.94,2.94,0,0,0,1,.19,3,3,0,0,0,1-5.81c-1-.37-2-.71-3-1h0c-1.28-.37-2.58-.7-3.88-1a3,3,0,1,0-1.21,5.88c1.14.23,2.28.52,3.39.85C83.59,19.63,84.48,19.93,85.35,20.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.51,25.79a40.7,40.7,0,0,1,4.4,3.79,3,3,0,0,0,2.11.87,2.93,2.93,0,0,0,2.13-.89,3,3,0,0,0,0-4.24,48.27,48.27,0,0,0-5-4.34,3,3,0,0,0-3.59,4.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.45,87.17A40.6,40.6,0,0,1,96.13,91a3,3,0,1,0,3.67,4.75,47.49,47.49,0,0,0,5-4.44,3,3,0,0,0-4.31-4.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.15,46a3,3,0,0,0,1.06-.19A3,3,0,0,0,115,41.94a47.92,47.92,0,0,0-2.8-6,3,3,0,1,0-5.25,2.91,39.77,39.77,0,0,1,2.44,5.26A3,3,0,0,0,112.15,46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.87,54.88a3,3,0,1,0-6,.48c.08,1.08.13,2.19.13,3.29,0,.84,0,1.69-.08,2.52a3,3,0,0,0,2.81,3.17h.19a3,3,0,0,0,3-2.82c.06-1,.09-1.92.09-2.88C118,57.39,118,56.13,117.87,54.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45,70.7a3,3,0,0,0-3.84,1.81,41.63,41.63,0,0,1-2.34,5.3,3,3,0,0,0,1.24,4.06,3.09,3.09,0,0,0,1.4.35,3,3,0,0,0,2.66-1.6,47.15,47.15,0,0,0,2.69-6.09A3,3,0,0,0,113.45,70.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,96.79c-.86.33-1.75.65-2.64.93a3,3,0,0,0,.91,5.86,3.13,3.13,0,0,0,.9-.14c1-.32,2-.68,3-1.07A3,3,0,1,0,86,96.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4,56.49a2.17,2.17,0,0,1-.36,0,3,3,0,0,1-2.63-3.33A46.92,46.92,0,0,1,67.83,11.8a3,3,0,0,1,.41,6A40.91,40.91,0,0,0,30.37,53.84,3,3,0,0,1,27.4,56.49Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileSnowLastHour);
export default __webpack_public_path__ + "static/media/tile_SnowLastHour.4c069ff63df8c82b14955fac0770b86d.svg";
export { ForwardRef as ReactComponent };